import { render, staticRenderFns } from "./DoctorsList.vue?vue&type=template&id=53d88efb&"
import script from "./DoctorsList.vue?vue&type=script&lang=js&"
export * from "./DoctorsList.vue?vue&type=script&lang=js&"
import style0 from "./DoctorsList.vue?vue&type=style&index=0&id=53d88efb&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports